import CRMApi from '@/api/crm'

export default {
    namespaced: true,
    state: {
        trialStatuses: [],
        trials: [],
        teachers: [],
        students: [],
        allTransactions: [],
        groups: [],
    },
    getters: {
        studentsWithGroup(state) {
            return state.students.filter(student => student.groups.length)
        },
        teachersWithGroup(state) {
            return state.teachers.filter(teacher => teacher.my_groups.length);
        }
    },
    mutations: {
        SET_TRIAL_STATUSES(state, trialStatuses) {
            state.trialStatuses = trialStatuses;
        },
        SET_TRIALS(state, trials) {
            state.trials = trials;
        },
        SET_TRIAL(state, trial) {
            state.trials.push(trial);
        },
        UPDATE_TRIAL(state, trial) {
            const editingTrialIndex = state.trials.findIndex(innerTrial => innerTrial.id === trial.id);
            state.trials.splice(editingTrialIndex, 1);
            state.trials.unshift(trial);
        },
        SET_STUDENTS(state, students) {
            state.students = students
        },
        SET_TEACHERS(state, teachers) {
            state.teachers = teachers
        },
        SET_ALL_TRANSACTIONS(state, val) {
            state.allTransactions = val;
        },
        SET_ALL_GROUPS(state, val) {
            state.groups = val;
        }
    },
    actions: {
        async getTrialStatuses({commit}) {
            let trialStatuses = await CRMApi.getTrialStatuses()
            if (trialStatuses.status === 200) {
                commit('SET_TRIAL_STATUSES', trialStatuses.data)
                return trialStatuses
            } else {
                throw trialStatuses
            }
        },
        async getTrials({commit}) {
            let trials = await CRMApi.getTrials()
            if (trials.status === 200) {
                commit('SET_TRIALS', trials.data);
            } else {
                throw trials
            }
        },
        async createTrial({commit}, trialData) {
            let trial = await CRMApi.createTrial(trialData)
            if (trial.status === 201) {
                commit('SET_TRIAL', trial.data);
                return trial.data
            } else {
                throw trial
            }
        },
        async getUsers({commit}) {
            let users = await CRMApi.getUsers();
            if (users.status === 200) {
                commit('SET_STUDENTS', users.data.students)
                commit('SET_TEACHERS', users.data.teachers)
                return users
            } else {
                throw users
            }
        },
        async getAllTransactions({commit}) {
            try {
                const transactions = await CRMApi.getTransactions()
                if (transactions.status === 200) {
                    commit('SET_ALL_TRANSACTIONS', transactions.data)
                    return transactions
                }
                throw new Error('status is not 200');
            } catch (e) {
                throw e;
            }
        },
        async getGroups({commit}) {
            try {
                const groups = await CRMApi.getGroups()
                if (groups.status === 200) {
                    commit('SET_ALL_GROUPS', groups.data)
                    return groups
                }
                throw new Error('status is not 200');
            } catch (e) {
                throw e;
            }
        },
        async createGroup({dispatch}, data) {
            try {
                const groups = await CRMApi.setGroup(data)
                dispatch('getGroups')
                return groups
                throw new Error('status is not 200');
            } catch (e) {
                throw e;
            }
        }
    }
};
